import { EvtHeader } from "components/header";
import React from "react";
import { useParams } from "react-router-dom";
import CostMasterForm from "../form";

const UpdateCostMaster = () => {
  const { costmasterId } = useParams();

  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Update Cost Master" />
      <div className="p-6 max-w-2xl">
        <CostMasterForm costmasterId={costmasterId} />
      </div>
    </div>
  );
};

export default UpdateCostMaster;
